import {
    CollectionDataLoaded,
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React, { useContext } from 'react'
import { CollectionDataContext } from '../../../contexts'
import {
    JournoProfileArticleCardList,
    JournoProfileArticleCardListProps,
} from './JournoProfileArticleCardList'

export const JournoProfileArticleCardListRegistration =
    createRegisterableComponentWithData(
        'journo-profile-card-list',
        ContentDataDefinitionLoader,
        (
            {
                expectedItemCount,
                adUnits,
                adTargeting,
            }: Omit<
                JournoProfileArticleCardListProps,
                'items' | 'onEvent' | 'api' | 'adState'
            >,
            { dataDefinitionArgs, ...initialData },
            { onEvent, adState, config },
        ) => {
            const { getCollectionData } = useContext(CollectionDataContext)

            const contextId =
                dataDefinitionArgs.type === 'context'
                    ? dataDefinitionArgs.contextId
                    : undefined

            let data: MaybeLoaded<CollectionDataLoaded> = initialData
            if (contextId) {
                data = getCollectionData(contextId)
            }

            return (
                <JournoProfileArticleCardList
                    items={
                        data.loaded
                            ? {
                                  loaded: true,
                                  result: data.result.publications,
                              }
                            : { loaded: false }
                    }
                    adUnits={adUnits}
                    expectedItemCount={expectedItemCount}
                    onEvent={onEvent}
                    api={config.contentApi}
                    adState={adState}
                    adTargeting={adTargeting}
                    config={config}
                />
            )
        },
    )
